// External Libraries
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

// UI Components
import SelectBox from "../../components/ui/SelectBox";
import SubmitButton from "../../components/ui/SubmitButton";
import FormField from "../../components/ui/FormField";

// Redux Actions
import { updateOrder } from "../../../store/custom-actions/orders-actions/ordersSlicer";

function UpdateCityForm({ show, onHide, order, submitLoading, onUpdateSuccess }) {
  const { t } = useTranslation(); // Initialize translation hook
  const dispatch = useDispatch();

  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm();

  useEffect(() => {
    if (order) {
      setValue("status", order.status);
      setValue("payment_status", order.payment_status);
      setValue("tracking_number", order.tracking_number || "");
      setValue("shipping_company", order.shipping_company || "");
      setValue("expected_delivery_date", order.expected_delivery_date || "");
    }
  }, [order, setValue]);

  const resetForm = () => {
    reset();
    onHide();
  };

  const onSubmit = async (data) => {
    const payload = { ...data };
    const result = await dispatch(
      updateOrder({
        id: order.id,
        data: payload,
      })
    );
    
    // If update was successful and callback provided, call it
    if (result.type === "orders/update/fulfilled" && onUpdateSuccess) {
      onUpdateSuccess(result.payload);
    }
    
    resetForm();
  };

  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{t("Update")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="submit-form-update" onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <SelectBox
                label="Order Status"
                name="status"
                register={register}
                required={true}
                errors={errors}
                showLabel={true}
                placeholder={t("Select order status")}
                data={[
                  { id: 0, name: t("Pending") },
                  { id: 1, name: t("Active") },
                  { id: 2, name: t("Delivery") },
                  { id: 3, name: t("Complete") },
                ]}
              />
            </div>
            <div className="mb-3">
              <SelectBox
                label="Payment Status"
                name="payment_status"
                register={register}
                required={true}
                errors={errors}
                showLabel={true}
                placeholder={t("Select order payment status")}
                data={[
                  { id: "pending", name: t("Pending") },
                  { id: "complete", name: t("Complete") },
                  { id: "failed", name: t("Failed") },
                ]}
              />
            </div>

            <div className="mb-3">
              <FormField
                label="Tracking Number"
                name="tracking_number"
                register={register}
                required={false}
                errors={errors}
                placeholder={t("Enter tracking number")}
              />
            </div>
            
            <div className="mb-3">
              <FormField
                label="Shipping Company"
                name="shipping_company"
                register={register}
                required={false}
                errors={errors}
                placeholder={t("Enter shipping company")}
              />
            </div>

            <div className="mb-3">
              <FormField
                label="Expected Delivery Date"
                name="expected_delivery_date"
                type="date"
                register={register}
                required={false}
                errors={errors}
                placeholder={t("Select expected delivery date")}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            {t("Close")}
          </Button>
          <SubmitButton isLoading={submitLoading} form="submit-form-update" />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdateCityForm;
